import React from "react";
import { useDarkMode } from "../../../darkmode/DarkModeContext";

const Section = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <section
      className={`relative overflow-hidden transition-all duration-500 ease-in-out ${
        isDarkMode
          ? "bg-gradient-to-br from-gray-900 via-green-900/20 to-gray-800 text-white"
          : "bg-gradient-to-br from-[#dfe4e0ff] via-white to-[#dfe4e0ff] text-gray-900"
      } pt-24`}
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className={`absolute -top-40 -right-40 w-80 h-80 rounded-full opacity-20 animate-pulse ${
            isDarkMode ? "bg-[#1E9B4C]" : "bg-[#1E9B4C]/30"
          }`}
        ></div>
        <div
          className={`absolute -bottom-32 -left-32 w-64 h-64 rounded-full opacity-10 animate-ping ${
            isDarkMode ? "bg-[#1E9B4C]" : "bg-[#1E9B4C]/40"
          }`}
          style={{ animationDuration: "4s" }}
        ></div>
      </div>

      <div className="container mx-auto px-6 py-20 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-center md:text-left transform hover:scale-105 transition-transform duration-300">
            <div className="mb-4">
              <span
                className={`inline-block px-4 py-2 rounded-full text-sm font-medium ${
                  isDarkMode
                    ? "bg-[#1E9B4C]/20 text-[#1E9B4C] border border-[#1E9B4C]/30"
                    : "bg-[#1E9B4C]/10 text-[#1E9B4C] border border-[#1E9B4C]/30"
                }`}
              >
                🛰️ Teknologi Terdepan
              </span>
            </div>

            <h1
              className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight ${
                isDarkMode
                  ? "bg-gradient-to-r from-[#1E9B4C] via-green-300 to-[#1E9B4C] bg-clip-text text-transparent"
                  : "bg-gradient-to-r from-[#1E9B4C] to-green-800 bg-clip-text text-transparent"
              } animate-fade-in-up`}
              style={{
                animation: "fadeInUp 0.8s ease-out",
              }}
            >
              Internet Satelit
              <br />
              <span className="relative">
                Starlink
                <div
                  className={`absolute -bottom-2 left-0 right-0 h-1 ${
                    isDarkMode
                      ? "bg-gradient-to-r from-[#1E9B4C] to-green-300"
                      : "bg-gradient-to-r from-[#1E9B4C] to-green-800"
                  } rounded-full opacity-60`}
                ></div>
              </span>
            </h1>

            <p
              className={`text-lg md:text-xl lg:text-2xl mb-8 max-w-lg leading-relaxed ${
                isDarkMode ? "text-gray-300" : "text-gray-600"
              } animate-fade-in-up`}
              style={{
                animation: "fadeInUp 0.8s ease-out 0.2s both",
              }}
            >
              Koneksi internet super cepat & stabil di mana saja, kapan saja.{" "}
              <span className="font-semibold text-[#1E9B4C]">
                Tanpa batas geografis!
              </span>
            </p>

            <div
              className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start animate-fade-in-up"
              style={{
                animation: "fadeInUp 0.8s ease-out 0.4s both",
              }}
            >
              {/* <button
                className={`group px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg ${
                  isDarkMode
                    ? "bg-gradient-to-r from-[#1E9B4C] to-green-700 hover:from-green-500 hover:to-[#1E9B4C] text-white shadow-green-500/25"
                    : "bg-gradient-to-r from-[#1E9B4C] to-green-600 hover:from-green-500 hover:to-[#1E9B4C] text-white shadow-green-500/25"
                } shadow-lg`}
              > */}
                {/* <span className="flex items-center gap-2">
                  Cek Ketersediaan
                  <svg
                    className="w-5 h-5 transform group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </span> */}
              {/* </button> */}

              {/* <button
                className={`group px-8 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 border-2 ${
                  isDarkMode
                    ? "border-gray-400 hover:border-[#1E9B4C] text-gray-300 hover:text-[#1E9B4C] hover:bg-[#1E9B4C]/10"
                    : "border-gray-300 text-gray-700 hover:border-[#1E9B4C] hover:text-[#1E9B4C] hover:bg-[#1E9B4C]/10"
                }`}
              >
                <span className="flex items-center gap-2">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Mulai Trial 30 Hari
                </span>
              </button> */}
            </div>

            {/* Stats */}
            <div className="mt-12 grid grid-cols-3 gap-6 text-center">
              <div className="transform hover:scale-110 transition-transform duration-300">
                <div
                  className={`text-2xl font-bold ${
                    isDarkMode ? "text-[#1E9B4C]" : "text-[#1E9B4C]"
                  }`}
                >
                  99.9%
                </div>
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Uptime
                </div>
              </div>
              <div className="transform hover:scale-110 transition-transform duration-300">
                <div
                  className={`text-2xl font-bold ${
                    isDarkMode ? "text-[#1E9B4C]" : "text-[#1E9B4C]"
                  }`}
                >
                  100+
                </div>
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Mbps
                </div>
              </div>
              <div className="transform hover:scale-110 transition-transform duration-300">
                <div
                  className={`text-2xl font-bold ${
                    isDarkMode ? "text-[#1E9B4C]" : "text-[#1E9B4C]"
                  }`}
                >
                  24/7
                </div>
                <div
                  className={`text-sm ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Support
                </div>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="flex justify-center md:justify-end relative">
            <div className="relative group">
              <div className="animate-float">
                <img
                  src="/image/starlink.png"
                  alt="Starlink Dish"
                  className={`rounded-2xl max-w-md w-full object-cover shadow-2xl transform group-hover:scale-105 transition-all duration-500 ${
                    isDarkMode ? "shadow-green-500/20" : "shadow-green-500/10"
                  }`}
                />
              </div>

              <div
                className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${
                  isDarkMode
                    ? "bg-gradient-to-r from-[#1E9B4C]/20 to-green-400/20"
                    : "bg-gradient-to-r from-[#1E9B4C]/30 to-green-300/30"
                } blur-xl -z-10`}
              ></div>

              <div className="absolute -top-4 -right-4 flex flex-col gap-2">
                <div
                  className={`w-3 h-3 rounded-full animate-ping ${
                    isDarkMode ? "bg-[#1E9B4C]" : "bg-[#1E9B4C]"
                  }`}
                ></div>
                <div
                  className={`w-2 h-2 rounded-full animate-pulse ${
                    isDarkMode ? "bg-[#1E9B4C]" : "bg-[#1E9B4C]"
                  }`}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default Section;